import { Configuration } from "../../../Components/Configuration";
import { HtmlController } from "../../../HTMLComponents/HtmlController";
import { PlayList } from "../../../Components/Sounds/PlayList";
import { NumberUtils } from "neo-common";
import { BetManager } from "../../../Managers/BetManager";
import { Languages } from "../../../Utils/Languages";
import { AppContext } from "../../../../Common/AppContext";
import { GameData } from "../Datas/GameData";
import { DataManager } from "../../../Managers/DataManager";
import { UserAction } from "../../../HTMLComponents/UserAction";
import { ModuleManager } from "../../../Managers/ModuleManager";
import { FreeRoundBonus } from "../Bonuses/FreeRoundBonus";
import { Platforms } from "neo-games";
import { BaseActions } from "../Actions/BaseActions";

export class Paytable {
    static Configurations = {
        PAYTABLE_COUNT_PREFIX: "",
        PAYTABLE_COUNT_POSTFIX: "",
        PAYTABLE_VALUE_PREFIX: "",
        PAYTABLE_VALUE_POSTFIX: "x",
    };

    public static instance: Paytable;
    public static userClosedPaytableAtStart: boolean = false;
    
    private static hasBeenDisplayed: boolean = false;
    private static payoutPage: number = -1;

    private _pages: HTMLCollectionOf<Element>;
    private _paginations: HTMLCollectionOf<Element>;
    private _defaultFontSize: number;
    private _defaultWidth: number;
    private _maxBet: number;

    constructor() {
        Paytable.instance = this;
    }

    initialize(): void {
        let prewPageButton: HTMLElement = document.getElementById("paytableButtonLeft");
        let nextPageButton: HTMLElement = document.getElementById("paytableButtonRight");

        if (prewPageButton != null) {
            prewPageButton.onclick = this.prewPage.bind(this);
        }

        if (nextPageButton != null) {
            nextPageButton.onclick = this.nextPage.bind(this);
        }

        this._pages = document.getElementsByClassName("paytablePage");
        this._paginations = document.getElementsByClassName("paytablePageNumber");

        this.updateDataValues();
    }

    public updateDataValues(): void {
        var config: Element = Configuration.Configurations["PaytableConfiguration"];

        if (config != null) {
            var data = {};
            var next: Element = config.firstElementChild;
            var maxValue = 0;
            while (next != null) {
                if (next.nodeName == "Pages") {
                    if (next.hasAttribute("Payouts")) {
                        Paytable.payoutPage = parseInt(next.getAttribute("Payouts")) - 1;
                    }
                } else if (next.hasAttribute("Symbol")) {
                    var id: string = next.getAttribute("Symbol");
                    var attrCounts: string = null;
                    var attrValues: string = null;

                    var i: number;
                    if (next.hasAttribute("Counts")) {
                        attrCounts = next.getAttribute("Counts");
                        var counts: Array<string> = next.getAttribute("Counts").split(";");
                        for (i = 0; i < counts.length; i++) {
                            data["PTB_SYMBOL_" + id + "_COUNT_" + (i + 1)] =
                                Paytable.Configurations.PAYTABLE_COUNT_PREFIX +
                                counts[i] +
                                Paytable.Configurations.PAYTABLE_COUNT_POSTFIX;
                        }
                    }

                    if (next.hasAttribute("Values")) {
                        attrValues = next.getAttribute("Values");
                        let valueSuffix = next.getAttribute("ValueSuffix");
                        var values: Array<string> = next.getAttribute("Values").split(";");
                        for (i = 0; i < values.length; i++) {
                            if (parseInt(values[i]) > maxValue) {
                                maxValue = parseInt(values[i]);
                            }
                            data["PTB_SYMBOL_" + id + "_VALUE_" + (i + 1)] = this.getPaytableValue(values[i]);
                        }
                    }
                }
                next = next.nextElementSibling;
            }

            if (AppContext != null && AppContext.gameConfiguration.PaytableUseValue) {
                let elements = document.getElementsByClassName("ptbTotalBetMultiplierDisplay");
                for (let i = 0; i < elements.length; i++) {
                    elements[i].classList.add("_hidden");
                }

                elements = document.getElementsByClassName("ptbTotalBetMultiplier");
                for (let i = 0; i < elements.length; i++) {
                    elements[i].classList.add("_invisible");
                }
            }

            if (data != null) {
                this.updateFontSize(maxValue, data);
                HtmlController.updateDataElements(data);
            }

            this.customContent();
        }
    }

    private getPaytableValue(value: string, valueSepratator: string = "-"): string {
        const valueArray = value.split(valueSepratator);

        for (let i = 0; i < valueArray.length; i++) {
            if (AppContext != null && AppContext.gameConfiguration.PaytableUseValue) {
                valueArray[i] =
                    Languages.formatText(Languages.FormatMoney, NumberUtils.multiply(valueArray[i], BetManager.Bet)) +
                    " " +
                    DataManager.getDataById(GameData.DataCurrency);
            } else {
                valueArray[i] =
                    Paytable.Configurations.PAYTABLE_VALUE_PREFIX +
                    valueArray[i] +
                    Paytable.Configurations.PAYTABLE_VALUE_POSTFIX;
            }
        }

        return valueArray.join(valueSepratator);
    }

    private updateFontSize(maxValue: number, data: Object): void {
        if (AppContext != null && !AppContext.gameConfiguration.PaytableUseValue) {
            return;
        }

        let elements = HtmlController.DataElements["PTB_SYMBOL_1_VALUE_1"];
        let conversionRate = 1;

        if (elements != null && elements.length > 0) {
            const element = elements[0].instance;
            element.removeAttribute("style");
            if (this._defaultWidth == undefined) {
                this._defaultFontSize = parseInt(window.getComputedStyle(element).fontSize);
                const defaultWidth = window.getComputedStyle(element).width;
                this._defaultWidth =
                    defaultWidth.indexOf("%") > -1 ? undefined : parseInt(window.getComputedStyle(element).width);
                this._maxBet = Math.max(...BetManager.TotalBets);
            }

            element.textContent =
                Languages.formatText(Languages.FormatMoney, NumberUtils.multiply(maxValue, BetManager.Bet)) +
                " " +
                DataManager.getDataById(GameData.DataCurrency);
            element.style.fontSize = this._defaultFontSize + "px";
            element.style.width = "auto";
            element.style.whiteSpace = "nowrap";
            element.offsetWidth;
            let currentWidth = parseFloat(window.getComputedStyle(element).width);
            conversionRate = this._defaultWidth / (currentWidth * 1.1); //1.1 is padding
            if (isNaN(conversionRate) || conversionRate > 1) {
                conversionRate = 1;
            }
            element.style.fontSize = "";
            element.style.width = "";
        }

        // let fontConversion = window['CHANNEL'] == 'mobile' ? 1.2 : 1.1;
        let fontConversion = window["CHANNEL"] == "mobile" ? 0.95 : 1;
        let fontSize = Math.floor(this._defaultFontSize * conversionRate * fontConversion) + "px";
        for (let key in data) {
            elements = HtmlController.DataElements[key];

            if (elements != null) {
                for (let i = 0; i < elements.length; i++) {
                    elements[i].instance.style.fontSize = fontSize;
                }
            }
        }
    }

    private customContent(): void {
        if (AppContext != null && !AppContext.gameConfiguration.PaytableUseValue) {
            return;
        }
    }

    private prewPage(): void {
        let activeIndex: number = this.disableElementsAndReturnActive();
        if (this._pages != null) {
            if (activeIndex === 0) {
                this._pages[this._pages.length - 1].classList.remove("_disabled");
                this._pages[this._pages.length - 1].classList.add("_active");
            } else {
                this._pages[activeIndex - 1].classList.remove("_disabled");
                this._pages[activeIndex - 1].classList.add("_active");
            }
            PlayList.play("SND_Click");
        }
        if (this._paginations != null) {
            if (activeIndex === 0) {
                this._paginations[this._paginations.length - 1].classList.remove("_disabled");
                this._paginations[this._paginations.length - 1].classList.add("_active");
            } else {
                this._paginations[activeIndex - 1].classList.remove("_disabled");
                this._paginations[activeIndex - 1].classList.add("_active");
            }
        }
    }

    private nextPage(): void {
        let activeIndex: number = this.disableElementsAndReturnActive();
        if (this._pages != null) {
            if (activeIndex === this._pages.length - 1) {
                this._pages[0].classList.remove("_disabled");
                this._pages[0].classList.add("_active");
            } else {
                this._pages[activeIndex + 1].classList.remove("_disabled");
                this._pages[activeIndex + 1].classList.add("_active");
            }
            PlayList.play("SND_Click");
        }
        if (this._paginations != null) {
            if (activeIndex === this._paginations.length - 1) {
                this._paginations[0].classList.remove("_disabled");
                this._paginations[0].classList.add("_active");
            } else {
                this._paginations[activeIndex + 1].classList.remove("_disabled");
                this._paginations[activeIndex + 1].classList.add("_active");
            }
        }
    }

    private setPage(page: number): void {
        if (page < 0 || page > this._pages.length - 1) {
            return;
        }

        this.disableElementsAndReturnActive();
        if (this._pages != null) {
            this._pages[page].classList.remove("_disabled");
            this._pages[page].classList.add("_active");
            (this._pages[page] as HTMLElement).scrollIntoView();
        }

        if (this._paginations != null) {
            this._paginations[page].classList.remove("_disabled");
            this._paginations[page].classList.add("_active");
        }
    }

    private disableElementsAndReturnActive(): number {
        let activeIndex: number = 0;
        for (var i: number = 0; i < this._pages.length; i++) {
            var element: HTMLElement = <HTMLElement>this._pages[i];
            if (element != null) {
                if (!element.classList.contains("_disabled")) {
                    element.classList.add("_disabled");
                }
                if (element.classList.contains("_active")) {
                    activeIndex = i;
                    element.classList.remove("_active");
                }
            }
        }

        for (var i: number = 0; i < this._paginations.length; i++) {
            var element: HTMLElement = <HTMLElement>this._paginations[i];
            if (element != null) {
                if (!element.classList.contains("_disabled")) {
                    element.classList.add("_disabled");
                }
                if (element.classList.contains("_active")) {
                    element.classList.remove("_active");
                }
            }
        }

        return activeIndex;
    }

    public static openAtStart(newGameRound: boolean = false): void {
        if (Paytable.shouldOpen(newGameRound)) {
            Paytable.show();
        }
    }

    public static show(): void {
        Paytable.hasBeenDisplayed = true;

        let dipatchElementId = UserAction.ActionPaytableOn;
        if (HtmlController.UiDispatchElements[dipatchElementId]) {
            let dipatchElement = HtmlController.UiDispatchElements[dipatchElementId][0];

            if (dipatchElement != null) {
                if (dipatchElement.instance.classList.contains(HtmlController.DisabledClass)) {
                    HtmlController.dispatchUiAction(UserAction.ActionPaytableOn);
                }
            }
        }

        Paytable.openPayoutPage();
        window.addEventListener("resize", Paytable.openPayoutPage);
    }

    public static close(action: string = ""): void {
        Paytable.clearListeners();

        const peakApp = document.querySelector("peak-app");
        const hasPendingNotifications =
            peakApp && peakApp.hasAttribute("pending-notifications-count") &&
            parseInt(peakApp.getAttribute("pending-notifications-count")!) > 0;
        if (
            Paytable.hasBeenDisplayed &&
            !Paytable.userClosedPaytableAtStart &&
            AppContext.gameConfiguration.ShowPaytableAtStart
        ) {
            Paytable.userClosedPaytableAtStart = true;
            if (action == BaseActions.ActionSpin || action == BaseActions.ActionAutoplay) {
                if (hasPendingNotifications) {
                    Platforms.Platforms.gamePlaySupressSpinOnCollect();
                }
            } else {
                Platforms.Platforms.roundInit();
            }
        }
    }

    private static openPayoutPage(): void {
        Paytable.instance.setPage(Paytable.payoutPage);
    }

    public static clearListeners(): void {
        window.removeEventListener("resize", Paytable.openPayoutPage);
    }

    public static shouldOpen(newGameRound: boolean = false, isSpin: boolean = false): boolean {
        if (!AppContext || !AppContext.gameConfiguration.ShowPaytableAtStart) {
            return false;
        }

        //if prepareNewGameRound was called before GameManager.showGame, ignore hasBeenDisplayed
        if (Paytable.hasBeenDisplayed && newGameRound) {
            return false;
        }

        if (ModuleManager.gambleActive()) {
            return false;
        }

        if (!DataManager.GameRoundClosed && !isSpin) {
            return false;
        }

        if (FreeRoundBonus.isLastFrb) {
            return false;
        }

        return true;
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Channels/Common/Paytable/Paytable.ts
 **/